import { gql, useLazyQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { EMPTY_ARRAY } from '@modules/common/constants';
import { Formula } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const FETCH_QUANTIFY_FORMULAS = gql`
  query getFormulas($tenantID: ID!, $field: String!) {
    getFormulas(request: { tenantID: $tenantID, field: $field }) {
      formulas {
        eqlFunction
        displayName
        isSupported
        description
        group
        helpCentreURL
        shortName
      }
    }
  }
`;

interface useFetchQuantifyFormulasParams {
  fetchPolicy?: WatchQueryFetchPolicy;
}

export function useFetchQuantifyFormulas(
  { fetchPolicy }: useFetchQuantifyFormulasParams = {
    fetchPolicy: 'cache-and-network',
  },
) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const [fetchFormulas, { loading, data }] = useLazyQuery<{
    getFormulas: { formulas: Formula[] };
  }>(FETCH_QUANTIFY_FORMULAS, {
    fetchPolicy,
  });

  const fetchQuantifyFormulas = useCallback(
    (field: string) => {
      fetchFormulas({
        variables: { tenantID, field },
        fetchPolicy,
      });
    },
    [fetchFormulas, tenantID, fetchPolicy],
  );

  return [
    fetchQuantifyFormulas,
    { isLoading: loading, formulas: data?.getFormulas.formulas ?? EMPTY_ARRAY },
  ] as const;
}
